(ns measure.reporting-ocp.view.tabs.display-variant-type
  (:require ["@mui/material/FormControlLabel$default" :as FormControlLabel]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Switch$default" :as Switch]
            ["@mui/material/Typography$default" :as Typography]
            [common.widgets.checkbox :refer [checkbox]]
            [common.widgets.dropdown :refer [dropdown]]
            [common.widgets.form-field :refer [form-field]]
            [common.widgets.radio :refer [radio-group]]
            [measure.reporting-ocp.db.core :as form]
            [measure.reporting-ocp.db.options :as form-options]
            [measure.reporting-ocp.view.tabs.fields :as tab-fields]
            [reagent.core :as r]
            [uix.core :as uix :refer [$ defui defhook]]))

(defui report-type []
  (let [{:keys [on-change]} (form/use-bind-control [:type])
        ad-variant-type-options (form-options/use-ad-variant-type-options)]
    (uix/use-effect #(on-change (:value (first ad-variant-type-options))))
    ($ form-field {:label "Report type"}
       (r/as-element
        [dropdown (assoc (form/use-bind-control [:type])
                         :options ad-variant-type-options)])
       ($ Typography {:color "text.secondary"}
          "Only 'Custom Report' available for now."))))

(defhook use-checkbox-group-controls [{:keys [on-change value]} field-name]
  {:on-change (uix/use-callback
               (fn [is-checked]
                 (on-change (vec ((if is-checked conj disj) (set value) field-name))))
               [on-change value field-name])
   :value (uix/use-memo #(contains? (set value) field-name) [value field-name])})

(defhook use-context-fields-controls [{:keys [on-change value]} options]
  {:on-change (uix/use-callback
               (fn [is-checked]
                 (on-change (if is-checked
                              (mapv :value options)
                              [])))
               [on-change value options])
   :value (uix/use-memo #(seq value) [value])
   :disabled? (empty? options)})

(defui columns []
  (let [columns-bind-control (form/use-bind-control [:columns])]
    (uix/use-effect (fn []
                      ;; Always include "Content ID" and "Dimension" for ad-variant reports
                      (let [current-columns (set (:value columns-bind-control))
                            required-columns #{"content_id" "dimension"}
                            updated-columns (into current-columns required-columns)]
                        (when (not= current-columns updated-columns)
                          ((:on-change columns-bind-control) (vec updated-columns)))))
                    [columns-bind-control])
    ($ form-field {:label "Columns:"}
       ($ Stack {:direction "column"}
          ($ checkbox {:disabled? true
                       :label "Content ID"
                       :value true})
          ($ checkbox {:disabled? true
                       :label "Dimension"
                       :value true})
          ($ checkbox (assoc (use-checkbox-group-controls columns-bind-control
                                                          "decision_tree_path")
                             :label "Decision path"))
          ($ checkbox (assoc (use-checkbox-group-controls columns-bind-control
                                                          "ad_variant_revision")
                             :label "Revision"))))))

(defui counts []
  ($ form-field {:label "Counts:"}
     (r/as-element
      [radio-group (merge (form/use-bind-control [:event-types])
                          {:options form-options/ad-variant-counts-options})])))

(defui option []
  (let [{:keys [on-change value]} (form/use-bind-control [:aggregate-daily])]
    ($ form-field {:label "Option:"}
       ($ FormControlLabel
          {:label "Aggregate by day"
           :labelPlacement "start"
           :control ($ Switch {:checked value
                               :onChange (fn [e] (on-change (-> e .-target .-checked)))})
           :sx #js {:gap 2 :mx 0}}))))

(defui ad-variant-display-type-tab []
  ($ :<>
     ($ report-type)
     ($ columns)
     ($ counts)
     ($ option)))

(defui ad-variant-video-type-tab []
  ($ :<>
     ($ report-type)
     ($ columns)
     ($ tab-fields/metrics-field)
     ($ option)))
